import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ReturnUrlType } from 'src/app/constants/authorization/api-authorization.constants';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { environment } from '../../../../environments/environment';
import { PingService } from '../../../services/ping.service';


// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.

interface INavigationState {
  [ReturnUrlType]: string;
}



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  public message = new BehaviorSubject<string | null | undefined>(null);

    public form: FormGroup;
    showPassword: boolean = false;
    submitted = false;

    private _authenticateSubscription?: Subscription;

    constructor(
        private _formBuilder: FormBuilder,
        private _authorizeService: AuthorizeService,
        private _router: Router) {

        this.form = this._formBuilder.group({
            userName: ["", [Validators.required]],
            password: [
                "",
                [
                    Validators.required
                ]
            ]
        }, { updateOn: 'change' });

    }
    ngOnDestroy(): void {
        this._authenticateSubscription?.unsubscribe();
    }


    ngOnInit(): void {
        // Is someone logged in?  Invalidate them.
        this._authorizeService.signOut();

        //clear all local and session storage
        localStorage.clear();
        sessionStorage.clear();

        document.documentElement.style.setProperty(`--theme-content-bg`, '#FFFFFF');
    }

    get formControl() {
        return this.form!.controls;
    }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
        const passwordInput = document.getElementById('inputPassword') as HTMLInputElement;
        passwordInput.type = this.showPassword ? 'text' : 'password';
      }

    onLogin(): void {
        this.submitted = true;
        if (this.form!.valid) {
            this._authenticateSubscription = this._authorizeService.authenticate$(this.form!.value).subscribe(response => {
                if(!!response && response.success) {
                    // Probably need a toast to say welcome response.firstName
                    this._router.navigate(["/dashboard/home"]);
                }
                else {
                    this.form?.controls['userName'].setValue('');   
                    this.form?.controls['password'].setValue('');   
                    this.form?.updateValueAndValidity();
                }
            },
            error => {
                // Probably need toast to indicate error.
                this.form?.controls['userName'].setValue('');   
                this.form?.controls['password'].setValue('');   
                this.form?.updateValueAndValidity();
            });
        }
    }
}

